"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The pure css circular loader indicator component
 **/
var CSSProgressLoader = function CSSProgressLoader() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.ldsRing,
    style: {
      width: '43px',
      height: '43px',
      margin: '0 auto',
      position: 'relative',
      display: 'none'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})]
  });
};

var PageLoadingSpinner = function PageLoadingSpinner(_ref) {
  var fullHeight = _ref.fullHeight,
      loadingMessage = _ref.loadingMessage;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      height: fullHeight ? '100vh' : 'auto',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    children: [loadingMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        marginBottom: '25px'
      },
      children: loadingMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CSSProgressLoader, {})]
  });
};

var _default = /*#__PURE__*/_react.default.memo(PageLoadingSpinner);

exports.default = _default;